import React from 'react';
import { SupplierLayout } from '../../components/SupplierLayout';
import { FileCheck, Bell } from 'lucide-react';
export function SupplierPermits() {
  return <SupplierLayout data-id="element-3494">
      <div className="h-full flex flex-col items-center justify-center max-w-md mx-auto text-center px-4 py-12" data-id="element-3495">
        <div className="w-24 h-24 rounded-3xl bg-brand-50 flex items-center justify-center mb-8 relative" data-id="element-3496">
          <div className="absolute inset-0 bg-brand-100 rounded-3xl blur-xl opacity-50" data-id="element-3497" />
          <FileCheck className="w-12 h-12 text-brand-500 relative z-10" data-id="element-3498" />
        </div>

        <h1 className="text-3xl font-display font-bold text-gray-900 mb-4" data-id="element-3499">
          Permits Management
          <br data-id="element-3500" />
          Coming Soon
        </h1>

        <p className="text-gray-500 mb-8 leading-relaxed" data-id="element-3501">
          We're building a centralized hub to track and renew your NOCs,
          hazardous goods permits, and cross-emirate licenses directly within
          Pair2.
        </p>

        <button className="flex items-center gap-2 px-6 py-3.5 bg-gray-900 hover:bg-black text-white rounded-xl font-bold transition-colors shadow-lg shadow-gray-900/20" data-id="element-3502">
          <Bell className="w-4 h-4" data-id="element-3503" /> Get notified when this launches
        </button>
      </div>
    </SupplierLayout>;
}